const OPTIONS = [
    { value: '', label: 'Automático (según categoría)' },
    { value: 'package_1kg', label: 'estándar' },
    { value: 'rods', label: 'rods' },
    { value: 'rods_long', label: 'rods_long' },
] as const;

/**
 * NULL y bulky no se muestran como estándar. bulky sigue oculto hasta que
 * el calculador y la función de presupuesto lo soporten. package_2kg se
 * conserva si ya está guardado.
 */
export function shippingPackageSelectValue(stored: string | null | undefined): string {
    const value = (stored || '').trim();
    if (!value || value === 'bulky') return '';
    if (OPTIONS.some((o) => o.value === value)) return value;
    if (value === 'package_2kg') return value;
    return '';
}

export function shippingPackagePatchValue(
    loaded: string,
    current: string,
): string | null | undefined {
    if (current === loaded) return undefined;
    return current === '' ? null : current;
}

export function ShippingPackageField({
    id,
    value,
    onChange,
}: {
    id: string;
    value: string;
    onChange: (value: string) => void;
}) {
    const extra = value === 'package_2kg' ? [{ value, label: value }] : [];
    return (
        <div className="space-y-1">
            <label htmlFor={id} className="text-sm font-medium">Tipo de paquete</label>
            <select
                id={id}
                className="h-10 w-full rounded-md border border-input bg-background px-3 text-sm"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {[...OPTIONS, ...extra].map((o) => (
                    <option key={o.value || 'auto'} value={o.value}>{o.label}</option>
                ))}
            </select>
            <p className="text-[10px] text-muted-foreground">
                Automático usa la categoría (caña = rods, el resto = estándar).
                Caña larga (rods_long) = embalaje de más de 1,30 m. Solo envío a Península y Portugal.
            </p>
        </div>
    );
}
